import { Component, ChangeDetectionStrategy } from '@angular/core';
import {Dialog} from '../../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../../interfaces/dialog/dialog-params';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {PartnerCappingRuleService} from '../../../../../../services/partner/partner-capping-rule.service';
import {PartnerCappingRule} from '../../../../../../models/partner/partner-capping-rule';
import {Partner} from '../../../../../../models/partner/partner';
import {SnackbarService} from '../../../../../../services/snackbar/snackbar.service';
import {DialogService} from '../../../../../../services/dialog/dialog.service';
import {OfferService} from '../../../../../../services/offer/offer.service';
import {Offer} from '../../../../../../models/offer';


@Component({
  selector: 'app-capping-rule-form',
  imports: [
    ReactiveFormsModule
],
  templateUrl: './capping-rule-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './capping-rule-form.component.scss'
})
export class CappingRuleFormComponent implements Dialog {

  partner: Partner | null = null;
  cappingRule: PartnerCappingRule | null = null;

  offers: Offer[] = [];

  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.maxLength(64)]),
    offerId: new FormControl('', [Validators.required]),
    periodicity: new FormControl('', [Validators.required]),
    capping: new FormControl('', [Validators.required]),
    blockTraffic: new FormControl(true),
    subid: new FormControl('', [Validators.maxLength(32)]),
  });

  constructor(
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private offerService: OfferService,
    private cappingRuleService: PartnerCappingRuleService
  ) {
  }

  onDialogInit(params: DialogParams): void {
    this.partner = params.data.partner;
    this.cappingRule = params.data.cappingRule;

    if (this.cappingRule) {
      this.form.patchValue({
        name: this.cappingRule.name,
        offerId: this.cappingRule.offer?.id ?? null,
        periodicity: this.cappingRule.periodicity,
        capping: this.cappingRule.capping,
        blockTraffic: this.cappingRule.blockTraffic,
        subid: this.cappingRule.subid,
      });
    }

    if (this.partner) {
      this.offerService.findPartnerOffers(this.partner).subscribe((offers: Offer[]) => {
        this.offers = offers;
      });
    }
  }

  submit(): void {
    const data: any = this.form.value;

    if (this.cappingRule?.id) {
      this.cappingRuleService.update(this.cappingRule.id, data).subscribe(() => {
        this.snackbar.success('Partner capping rule created.');
        this.dialog.closeDialog(true);
      });
    } else {
      if (this.partner?.id) {
        data['partnerId'] = this.partner.id;
      }

      this.cappingRuleService.create(data).subscribe(() => {
        this.snackbar.success('Partner capping rule created.');
        this.dialog.closeDialog(true);
      });
    }
  }

}
